import { ActionCreatorWithPayload, PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import { INotificationActionPayload } from '../features/notif/model';
import { resolveApiRegularErrorMessage, resolveApiValidationErrorMessage } from '../services/util/error/apiError';
import { instanceOfRegularErrorResponse, instanceOfValidationErrorResponse } from '../util/customTypeGuards';

export function* handleApiErrorNotification(
	error: any,
	failAction: ActionCreatorWithPayload<INotificationActionPayload>,
	defaultMessage?: string
) {
	if (error.response && error.response.data && instanceOfValidationErrorResponse(error.response.data)) {
		yield put(
			failAction({
				errorToBeLogged: null,
				notification: {
					message: resolveApiValidationErrorMessage(error.response, error.response.data),
					notificationDuration: 5000,
					type: 'error',
				},
			})
		);
	} else if (error.response && error.response.data && instanceOfRegularErrorResponse(error.response.data)) {
		yield put(
			failAction({
				errorToBeLogged: error,
				notification: {
					message: resolveApiRegularErrorMessage(error.response, error.response.data),
					notificationDuration: 5000,
					type: 'error',
				},
			})
		);
	} else {
		yield put(
			failAction({
				errorToBeLogged: error,
				notification: {
					message: defaultMessage || 'Unknown error occured!',
					notificationDuration: 5000,
					type: 'error',
				},
			})
		);
	}
}
